export default {
    notes_tab_title: 'Notes',
    notes_tab_created_by: 'Created By',
    notes_tab_created_on: 'Created On',
    notes_tab_updated_by: 'Updated By',
    notes_tab_updated_on: 'Updated On',
    notes_tab_note: 'Note',
    notes_tab_edit: 'Edit',
    notes_tab_add_note: 'Add Note',
    notes_tab_project: 'Project'
    

};







